import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from './components/components.module';
import { EmptyViewModule } from './components/empty-view/empty-view.module';
import { ImgFallbackModule } from 'ngx-img-fallback';
import { PipesModule } from './pipes/pipes.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BarRatingModule } from 'ngx-bar-rating';
import { FooterModule } from './components/footer/footer.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    ComponentsModule,
    ImgFallbackModule,
    LazyLoadImageModule,
    EmptyViewModule,
    PipesModule,
    BarRatingModule,
    FooterModule,
  ],
  exports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    ComponentsModule,
    ImgFallbackModule,
    LazyLoadImageModule,
    EmptyViewModule,
    PipesModule,
    BarRatingModule,
    FooterModule,
  ],
  providers: [],
})
export class SharedModule {}
